import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  limparProcesso,
  buscarInfracao,
  buscarProcesso,
  quandoMudar,
  salvar
} from "./actions";
import { exibirMensagem, fecharMensagem } from "componentes/mensagem/actions";
import { pegarProcesso } from "./seletor";
import {
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';

import Pagina from 'componentes/Pagina';
import PesquisaAutoInfracao from 'componentes/PesquisaAutoInfracaoForm';
import AutoInfracaoResumo from 'componentes/AutoInfracaoResumo';
import ProcessoForm from 'componentes/ProcessoForm';

import { adicionarAlegacoes } from "../pesquisaprocesso/actions";


class Processo extends Component {
  componentDidMount() {
    const { id, processo: { id: processoId }, buscarProcesso } = this.props;
    if (id && id !== processoId) {
      return buscarProcesso(id);
    }
  }

  render() {
    const titulo = this.props.id ? "Atualizar Processo" : "Cadastrar Processo";
    return (
      <Pagina title={titulo} breadcrumbs={[{ name: titulo, active: true }]} >
        <Row>
          {
            !this.props.id &&
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <PesquisaAutoInfracao {...this.props} />
                </CardBody>
              </Card >
            </Col>
          }
          {
            this.props.infracao.codigo &&
            <Fragment>
              <Col xl={12} lg={12} md={12}>
                <AutoInfracaoResumo {...this.props} />
              </Col>
              <Col xl={12} lg={12} md={12}>
                <ProcessoForm {...this.props} />
              </Col>
            </Fragment>
          }
        </Row>
      </Pagina>
    );
  }
}

const mapStateToProps = (state, { history, match: { params: { id } } }) => ({
  id: id ? parseInt(id, 10) : "",
  history,
  ...pegarProcesso(state, id),
  tiposProcesso: state.processo.tiposProcesso,
  tiposConta: state.processo.tiposConta,
  bancos: state.processo.bancos,
  tiposRequerente: state.processo.tiposRequerente,
  mensagem: state.processo.mensagem,
  alegacoes: state.pesquisaprocesso.alegacoes,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  buscarProcesso,
  buscarInfracao,
  limparProcesso,
  quandoMudar,
  salvar,
  adicionarAlegacoes,
  exibirMensagem,
  fecharMensagem
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Processo))


// WEBPACK FOOTER //
// ./src/paginas/processo/index.js